<template>
  <div>
    <BModal
      id="modal-not-registered-whitelisted"
      ref="modal-not-registered-whitelisted"
      no-stacking
      centered
      hide-footer
      hide-header
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <BRow class="justify-center my-1 flex flex-column">
        <BCol
          class="flex flex-col text-center gap-2 justify-content-center mb-2"
        >
          <div class="flex justify-center mb-2">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
              alt="Warning"
              width="72"
              height="72"
            >
          </div>
          <strong class="text-black text-xl">
            Kamu Belum Terdaftar Sebagai Partner Whitelisted
          </strong>
          <span class="text-black text-md">
            Silahkan lakukan pendaftaran Komads Whitelisted untuk bisa melakukan
            top up saldo Whitelisted
          </span>
        </BCol>
        <BCol class="flex justify-center gap-2">
          <BButton
            variant="outline-secondary"
            class="rounded-lg px-4 grow"
            @click="closeModal"
          >
            Batal
          </BButton>
          <BButton
            variant="primary"
            class="rounded-lg bg-[#FF5C00] border-[#FF5C00] text-white px-4 grow"
            @click="setupAccount"
          >
            Setup Akun
          </BButton>
        </BCol>
      </BRow>
    </BModal>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * Close the modal
     */
    closeModal() {
      this.$bvModal.hide('modal-not-registered-whitelisted')
    },

    /**
     * Navigate to whitelisted account setup page
     */
    setupAccount() {
      this.closeModal()
      this.$router.push({ name: 'whitelisted-account' })
    },
  },
}
</script>
